import type { Tool, ToolContext, ToolPoint } from './Tool'

export class MarkerTool implements Tool {
  readonly id = 'marker'
  private points: ToolPoint[] = []
  private drawing = false

  onPointerDown(ctx: ToolContext, point: ToolPoint): void {
    this.drawing = true
    this.points = [point]
    const { ctx: c, color, brushSize } = ctx
    c.lineCap = 'round'
    c.lineJoin = 'round'
    c.strokeStyle = color.hex
    c.fillStyle = color.hex
    c.lineWidth = brushSize.px
    c.beginPath()
    c.arc(point.x, point.y, brushSize.px / 2, 0, Math.PI * 2)
    c.fill()
  }

  onPointerMove(ctx: ToolContext, point: ToolPoint): void {
    if (!this.drawing) return
    this.points.push(point)
    const { ctx: c, color, brushSize } = ctx
    c.lineCap = 'round'
    c.lineJoin = 'round'
    c.strokeStyle = color.hex
    c.lineWidth = brushSize.px

    const n = this.points.length
    if (n < 3) {
      const p0 = this.points[0]
      const p1 = this.points[1]
      c.beginPath()
      c.moveTo(p0.x, p0.y)
      c.lineTo(p1.x, p1.y)
      c.stroke()
      return
    }

    const p0 = this.points[n - 3]
    const p1 = this.points[n - 2]
    const p2 = this.points[n - 1]
    const midA = { x: (p0.x + p1.x) / 2, y: (p0.y + p1.y) / 2 }
    const midB = { x: (p1.x + p2.x) / 2, y: (p1.y + p2.y) / 2 }
    c.beginPath()
    c.moveTo(midA.x, midA.y)
    c.quadraticCurveTo(p1.x, p1.y, midB.x, midB.y)
    c.stroke()
  }

  onPointerUp(_ctx: ToolContext, _point: ToolPoint): void {
    this.drawing = false
    this.points = []
  }

  cancel(): void {
    this.drawing = false
    this.points = []
  }
}
